import { render, staticRenderFns } from "./SupaRegistriesPage.vue?vue&type=template&id=7401dfec&scoped=true&"
import script from "./SupaRegistriesPage.vue?vue&type=script&lang=js&"
export * from "./SupaRegistriesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7401dfec",
  null
  
)

export default component.exports